import { Box, Text, styled } from '@ltvco/refresh-lib/theme';

export const HeaderContainer = styled(Box)(({ theme }) => ({
  display: 'none',
  flexDirection: 'column',
  gap: theme.spacing(2),
  width: '100%',
  padding: theme.spacing(2, 2, 2.5, 2),
  [theme.breakpoints.down('sm')]: {
    display: 'flex',
  },
}));

export const TitleRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: theme.spacing(1),
}));

export const IconContainer = styled(Box)(({ theme }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
  '& .MuiSvgIcon-root': {
    fontSize: 35,
    color: theme.palette.primary.main,
  },
}));

export const TitleText = styled(Text)(({ theme }) => ({
  fontWeight: 700,
  fontSize: '30px',
  lineHeight: 1,
  color: theme.palette.text.primary,
  marginTop: theme.spacing(0.5),
}));

export const DescriptionText = styled(Text)(({ theme }) => ({
  fontSize: '16px',
  lineHeight: '24px',
  fontWeight: 400,
  color: theme.palette.text.primary,
}));
